import { firebaseAction } from 'vuexfire'
import { db } from '@/db'

const ranges = db.collection('ranges')

const state = {
  ranges: []
}

const actions = {
  getRanges: firebaseAction(({ bindFirebaseRef }, filterId) => {
    bindFirebaseRef('ranges',
      ranges
        .where('filterId', '==', filterId)
        .orderBy('order')
    )
  }),

  clearRanges ({ commit }) {
    commit('CLEAR_RANGES')
  }
}

const mutations = {
  CLEAR_RANGES (state) {
    state.ranges = []
  }
}

const getters = {
  currentRanges: (state) => state.ranges
}

const namespaced = true

export default {
  namespaced,
  state,
  actions,
  mutations,
  getters
}
